import React, { useCallback, useState } from "react";
import { useDropzone } from "react-dropzone";
import { FormattedMessage } from "react-intl";

interface DropzoneProps {
  onFileAccepted: (file: File) => void;
}

const Dropzone: React.FC<DropzoneProps> = ({ onFileAccepted }) => {
  const [file, setFile] = useState<File | null>(null);

  const onDrop = useCallback(
    (acceptedFiles: File[]) => {
      if (acceptedFiles.length > 0) {
        setFile(acceptedFiles[0]);
        onFileAccepted(acceptedFiles[0]);
      }
    },
    [onFileAccepted],
  );

  const { getRootProps, getInputProps, isDragActive } = useDropzone({
    onDrop,
    accept: {
      "text/csv": [".csv"],
    },
    multiple: false,
  });

  return (
    <div
      {...getRootProps()}
      className={`upload-zone dropzone dz-clickable ${
        isDragActive ? "is-active" : ""
      }`}
    >
      <input {...getInputProps()} />
      <div className="dz-message" data-dz-message>
        <span className="dz-message-text">
          <FormattedMessage id="Drag and drop file" />
        </span>
        <span className="dz-message-or">
          <FormattedMessage id="or" />
        </span>
        <button className="btn btn-primary">
          <FormattedMessage id="SELECT" />
        </button>
      </div>
      {file && (
        <div className="mt-3 text-center">
          <strong>
            <FormattedMessage id="Selected file" />:
          </strong>{" "}
          {file.name}
        </div>
      )}
    </div>
  );
};

export default Dropzone;
